var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockRectangleStackOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 11C25 8.79086 23.2091 7 21 7H7C4.79086 7 3 8.79086 3 11V20C3 22.2091 4.79086 24 7 24H21C23.2091 24 25 22.2091 25 20V11ZM7 9H21C22.1046 9 23 9.89543 23 11V20C23 21.1046 22.1046 22 21 22H7C5.89543 22 5 21.1046 5 20V11C5 9.89543 5.89543 9 7 9ZM19.9945 4.85074C19.9182 3.81588 19.0544 3 18 3H10C8.89543 3 8 3.89543 8 5H20L19.9945 4.85074ZM13.4 10.75C14.0351 10.75 14.55 11.2649 14.55 11.9V15.603L17.8038 16.8232C18.3985 17.0462 18.6998 17.7091 18.4768 18.3038C18.2538 18.8985 17.5909 19.1998 16.9962 18.9768L12.9962 17.4768C12.5474 17.3085 12.25 16.8794 12.25 16.4V11.9C12.25 11.2649 12.7649 10.75 13.4 10.75Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRectangleStackOutline);
export default __webpack_public_path__ + "static/media/clock_rectangle_stack_outline.a1747ae316a9b818be9f8f69623070a0.svg";
export { ForwardRef as ReactComponent };